import { z } from 'zod';

export const tourSequenceDtoSchema = z.object({
  id: z.number(),
  name: z.string(),
});

export const getTourSequencesDtoSchema = z.object({
  data: z.array(tourSequenceDtoSchema),
  limit: z.number(),
  skip: z.number(),
  total: z.number(),
});

export type TourSequenceDto = z.infer<typeof tourSequenceDtoSchema>;
